import UsersForm from "../utils/UsersForm";

export default class UsersEdit {

    constructor() {
        this.usersForm = new UsersForm();
        this.bindEvents();
        //window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.usersForm.onDestroy();
    }
}